import script from "./ButtonNavigations.vue?vue&type=script&lang=ts&setup=true"
export * from "./ButtonNavigations.vue?vue&type=script&lang=ts&setup=true"

import "./ButtonNavigations.vue?vue&type=style&index=0&id=5bcf3396&lang=css"

const __exports__ = script;

export default __exports__